import { Chart, Plugin } from 'chart.js';

export class QaroniRequiredProgressBarPlugin implements Plugin<'bar', unknown> {
  id: 'qaroniRequiredProgressBar';
  public progressRequired: number;

  constructor(progressRequired: number = 0) {
    this.progressRequired = progressRequired;
  }

  beforeDraw(chart: Chart<'bar'>) {
    if (this.progressRequired > 0) {
      const ctx = chart.ctx;
      ctx.save();
      const xAxis = chart.scales.x;
      const yAxis = chart.scales.y;
      const progressObtainedPosition = xAxis.getPixelForValue(
        this.progressRequired
      );
      const barHeight = yAxis.bottom - yAxis.top;

      ctx.fillStyle = 'rgb(222, 226, 230)';
      ctx.fillRect(
        xAxis.left,
        yAxis.top,
        progressObtainedPosition - xAxis.left,
        barHeight
      );
      ctx.restore();
    }
  }

  afterDraw(chart: Chart<'bar'>) {
    if (this.progressRequired > 0) {
      const ctx = chart.ctx;
      ctx.save();
      const xAxis = chart.scales.x;
      const yAxis = chart.scales.y;
      const progressObtainedPosition = xAxis.getPixelForValue(
        this.progressRequired
      );
      const barHeight = yAxis.bottom - yAxis.top;
      ctx.fillStyle = '#000000';
      ctx.fillRect(progressObtainedPosition - 2, yAxis.top, 5, barHeight);
      ctx.restore();
    }
  }
}
